/**
 * Created by PhpStorm.
 * Copyright: David Obdržálek, Carpe Noctem, s.r.o.
 * Date: 2019-01-22 16:19
 */

include('inc/carpe.basic.js');
include('inc/carpe.fx.js');
// include('inc/carpe.socgal.js');
// include('script.maps.js');

$(() => {
  // profile fce

  $('#menu').on('load', function(e, category, level, after) {
    let menu = $('#menu .menu').first()
        .html('').removeClass('error').addClass('loading'),
        url = '/api/menu/display/' + encodeURI(category) + '?level=' + (level || '') + '&html';

    // console.log(url);
    $.ajax(url, { cache: false })
        .done(resp => {
          menu.html(resp)
              .removeClass('loading error');

          // if (category === 'Obědy'
          //     && !$('.category', menu)
          //         .map((i,r) => $(r).data('name'))
          //         .filter((i, r) => (r || '').match(/ (\d+)\.(\s*)(\d+)\.$/))
          //         .length)
          //   return Carpe.orderFormError();

          if (typeof after === "function")
            after();
        })
        .fail(resp => {
          let msg = (resp.responseJSON ? resp.responseJSON.message : null) || resp.responseText;
          menu.html(`<h5 class='center red'>${msg}</h5>`)
              .removeClass('loading').addClass('error');
        });
  });

  $('#scroll-profile a[href="#order"]').off('click').on('click', function(e, after) {
    e && e.stop();
    if ($(this).prop('disabled'))
      return;

    Carpe.orderInit();

    if (typeof after === "function")
      after();
  });
});

Carpe.scrollOffset = 170;

Carpe.orderInit = function() {
  let menu = $('#scroll-profile #menu').first(),
      form = $('form', menu).first(),
      level = $('input[name="data[pricelevel]"]', form).val(),
      render = () => {
        $('.menudrop', form).first().replaceWith($('#scroll-profile #menu .menu').first());
        form.removeClass('hide');
        Carpe.orderForm();
      }
  if ($('.fail, .success', form).is(':visible'))
    location.reload();

  menu.trigger('load', [
    'Covid',
    level,
    render
  ]);

  // if (e.originalEvent || !!after) {
  //   menu.scrollTo(null, 72);
  //   (typeof ga === "function") &&
  //   ga('send', 'event', 'Objednávka', 'Otevřít', document.title.split(',').shift());
  //   (typeof fbq === "function") &&
  //   fbq('track', 'Lead');
  // }
}

Carpe.orderFormError = () => {
  $('#menu form .recap').hide();
  $('#menu .menu').first().html(`
      <div class="center m50">
        <h4>Nabídku připravujeme...</h5>
      </div>`);
  return false;
};

Carpe.orderForm = function() {
  let form = $('#menu form').first(),
      menu = $('#menu .menu').first();
  if (!form.length || !menu.length)
    return;

  if ($('tr .qty input', menu).length)
    return;

  let today = new Date(form.data('date')),
      dayw = today.getDay() % 7,
      day  = [null, 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', null, null][dayw];

  // if (!day) {
  //   if (location.hostname.indexOf('.loc') > 0)
  //     day = 'Pátek';
  //   else
  //     return Carpe.orderFormError();
  // }

  // let check = 0;
  // $('.category', menu).each((i, cat) => {
  //   cat = $(cat);
  //   if (cat.data('name').match(/ (\d+)\.(\s*)(\d+)\./)) {
  //     if (cat.data('name').includes(day)) {
  //       cat.show(); check++;
  //     } else
  //       cat.hide();
  //   }
  // });
  // if (!check)
  //   return Carpe.orderFormError();

  $('tr', menu).each((i, tr) => {
    tr = $(tr);
    let input = $(`<input type="number" name="data[order][${tr.data('product')}]" data-price="${tr.data('price')}" value="" min="0" max="20">`)
        .prop('disabled', tr.hasClass('soldout'))
        .on('change', function() {
          let val = atoi($(this).val());
          $(this).parents('tr').first().toggleClass('active', val > 0);
          form.trigger('recount');
        });
    tr.prepend($('<td class="qty">').html(input));
    tr.on('click', function(e) {
      if (e.target.nodeName === 'INPUT')
        return;
      let inp = $('input', this).first();
      if (inp.prop('disabled'))
        return;
      inp.val(atoi(inp.val())+1).trigger('change');
    });
  });

  form
  .on('recount', function() {
    let qty = 0, qty_pack = 0, price = 0,
        is_delivery = $('[name="data[delivery]"]', this).val() === 'delivery';

    for (const inp of $('[name^="data[order]"]', this)) {
      let q = atoi($(inp).val()),
          tr = $(inp).parents('tr').first();
      price += q*atoi($(inp).data('price'));
      qty += q;
      if (['Covid Nápoje', 'Covid Omáčky', 'Covid Přílohy'].indexOf(tr.data('category')) < 0)
        qty_pack += q;
    }

    $('.recap', this).toggle(price > 0);
    $('textarea[name="data[address]"]', this)
        .prop('required', is_delivery)
        .parent().toggle(is_delivery);
    $('select[name="data[time]"]', this)
        .prop('required', !is_delivery)
        .parent().toggle(!is_delivery);

    let packprice = 10, // $('[name="data[delivery]"]', this).val() === 'takeaway' ? 0 : 10,
        packaging = qty_pack * packprice,
        delivery_price = ($('input[name="data[route][price]"]').val() || '0').atoi(),
        delivery_free = ($('input[name="data[route][free]"]').val() || '350').atoi(),
        delivery = is_delivery && price < delivery_free ? delivery_price : 0,
        total = price + packaging + delivery;

    // console.log(packaging, is_delivery, delivery_price, delivery_free)
    $('.recap .price.food', this).text((price || '0').price('Kč'));
    $('.recap .price.packaging', this).text((packaging || '0').price('Kč'));
    $('.recap .price.delivery', this).text((delivery_price || !is_delivery) ? (delivery || '0').price('Kč') : '?');
    $('.recap .price.total', this).text((total || '0').price('Kč'));
  })
  .on('submit', function(e) {
    let value = atoi($('.recap .price.total', this).text());

    (typeof ga === "function")
      && ga('send', 'event', 'Objednávka', 'Odeslat', document.title.split(',').shift(), value);
    (typeof fbq === "function")
      && fbq('track', 'Purchase', {currency: "CZK", value: value});
  })
  .trigger('recount')
  .ajaxForm();

  $('[name="data[delivery]"]', form).off('change').on('change', function(e) {
    e && e.stop()
    let is_delivery = $(this).val() === 'delivery';
    $('.geolocation', form).toggle(is_delivery)
    $('.geolocation input[name="data[address]"]', form).val('').prop('required', is_delivery)
    $('.geolocation .info > *', form).addClass('hide')

    form.trigger('recount')
  });
  $('input[name="data[phone]"]', form).off('keyup').on('keyup', function(e) {
    if ($(this).val().match(/\s+/)) {
      $(this).val($(this).val().replace(/\s+/g, ''))
      e.preventDefault()
    }
  });

  $('.switch a', form).off('click').on('click', function(e) {
    e && e.stop();
    let swi = $(this).parents('.switch').first();

    if ($(this).attr('disabled')) return;
    // if ($('.active', swi).get(0) === this) return;

    $('.active', swi).removeClass('active');
    $(this).addClass('active');

    $(`[name="data[${$(this).data('key')}]"]`)
        .val($(this).data('value'))
        .trigger('change')
  });

  if (!$('.switch a.active', form).length)
    $('.switch a:not([disabled])', form).first().trigger('click');
  return form;
};

// delivery only
window.initDeliveryAutocomplete = () => {
  let form = $('#menu form').first();
  if (!form || $('[name="data[delivery]"]', form).val() !== 'delivery') return;

  let input = $('[name="data[address]"]', form);
  if (!input.length) return;

  const AC = new google.maps.places.Autocomplete(
      input.get(0),
      { componentRestrictions: { country: 'cz' } });
  AC.setFields(['address_components', 'place_id', 'geometry', 'url'])
  const DS = new google.maps.DirectionsService()

  input.on('blur', function() {
    setTimeout(() => {
      if (!$(this).is(':focus') && !$('.geolocation input[name="data[route][distance]"]', form).val())
        $(this).val('');
    }, 1000);
  })

  AC.addListener("place_changed", () => {
    const place = AC.getPlace();
    // console.log(place);
    $('.geolocation .info p', form).addClass('hide');

    if (!place || !place.geometry || !place.geometry.location
      || !place.address_components || !place.address_components.some(r => (r.types.includes("street_number") || r.types.includes("premise")))) {
      $('.geolocation input[name="data[route][distance]"]', form).val('')
      $('.geolocation .info p.invalid', form).removeClass('hide')

      let pos = input.val().indexOf(',')
      input[0].focus()
      input[0].setSelectionRange(pos, pos)
      return
    }

    $('.geolocation input[name="data[route][gps]"]', form).val(place.geometry.location.toString().replace(/[\(\)]/g, ''))
    $('.geolocation input[name="data[route][url]"]', form).val(place.url)

    DS.route({
      origin: Carpe.origin,
      destination: place.geometry.location,
      travelMode: google.maps.TravelMode.DRIVING
    }, (resp, status) => {
      if (status !== 'OK' || !resp.routes[0] || !resp.routes[0].legs[0].distance.value) {
        $('.geolocation .info p').addClass('hide');
        $('.geolocation .info p.invalid').removeClass('hide');
        setTimeout(() => input.attr('placeholder', input.val()).val(''), 100);
      } else {
        let route = resp.routes[0],
            distance = route.legs[0].distance.value / 1000,
            [tarif, price, free ] = Carpe.resolveDeliveryPrice(distance)

        $('.geolocation input[name="data[route][distance]"]', form).val(distance)
        $('.geolocation input[name="data[route][tarif]"]', form).val(tarif)
        $('.geolocation input[name="data[route][price]"]', form).val(price)
        $('.geolocation input[name="data[route][free]"]', form).val(free)

        $('.geolocation .info p .distance', form).html(distance.price('km', 1))
        $('.geolocation .info p .tarif', form).html(tarif.price('km'))
        $('.geolocation .info p .price', form).html(price.price('CZK'))
        $('.geolocation .info p .free', form).html(free.price('CZK'))

        if (tarif) {
          $('.geolocation .info p.inrange', form).removeClass('hide');
          form.trigger('recount')
        } else {
          $('.geolocation .info p.outofrange', form).removeClass('hide');
          $('.geolocation input[name="data[route][distance]"]', form).val('');
          setTimeout(() => input.attr('placeholder', input.val()).val(''), 100);
        }
      }

    });

  });
}

Carpe.resolveDeliveryPrice = (distance) => {
  return distance < 5.5
      ? [5, 29, 500]
      : [0,0,0]
}
